import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './TelegramModal.css';
import Aux from '../../hoc/Auxiliary/Auxiliary';
import Backdrop from '../UI/Backdrop/Backdrop';
import personImg from '../../assets/images/person-icon.png';
import deleteImg from '../../assets/images/delete-icon.png';
import closeImg from '../../assets/images/close-icon.png';
import arrowImg from '../../assets/images/arrow-right-icon.png';
import phoneImg from '../../assets/images/phone-icon.png';
import plusImg from '../../assets/images/plus-icon.png';
import telegramImg from '../../assets/images/telegram-icon.png';
import sideBySideImg from '../../assets/images/side-by-side-icon.png';
import stackedImg from '../../assets/images/stacked-icon.png';
import axios from '../../axios-trips';
import logError from '../../store/LogError';
import * as actionTypes from '../../store/actions';
import chatImg from '../../assets/images/chat-white-icon.png';
import historyImg from '../../assets/images/history-icon.png';
import Icon from '../UI/Icon/Icon';
import Button from '../UI/Button/Button';
import ButtonIconConfirm from '../UI/ButtonIconConfirm/ButtonIconConfirm';
import ButtonIcon from '../UI/ButtonIcon/ButtonIcon';
import Input from '../UI/Input/Input';
import Spinner from '../UI/Spinner/Spinner';
import Modal from '../UI/Modal/Modal';

class TelegramModal extends Component {

  createInputConfig = (elementType,
                       elementConfig,
                       label,
                       value='',
                       validation={},
                       valid=true,
                       extraAction=null,
                       extraClass=null) => {
    return ({
      elementType: elementType,
      elementConfig: elementConfig,
      label: label,
      value: value,
      validation: validation,
      valid: valid,
      extraAction: extraAction,
      extraClass: extraClass,
      touched: false,
      errorMessage: null
    });
  }

  state = {
    localCard: null,
    loading: false,
    selectedMessage: 'Ищем машину',
    selectedChannel: -1001252662540,
    telegramMessageOptions: {
      telegramOptions: this.createInputConfig(
          'select',
          {
            options: [
              { value: "Ищем машину", displayValue: "Ищем машину" },
              { value: "Изменения к рейсу", displayValue: "Изменения к рейсу" },
              { value: "Предложена цена", displayValue: "Предложена цена" },
              { value: "Найдена машина", displayValue: "Найдена машина" },
              { value: "Ищем замену", displayValue: "Ищем замену" },
            ]
          },
          'Тип Сообщения: ',
          'Ищем машину',
          { required: false },
          true,
          null,
          classes.InlineInput),
        channel: this.createInputConfig(
          'checklist',
          {
            options: [
              { value: -1001252662540, displayValue: "Диспетчеры Сервисопторг", checked: true },
              { value: -1001477577735, displayValue: "Диспетчеры для Сервисопторга", checked: true },
              { value: "managers", displayValue: "Менеджеры Рейса", checked: false },
              { value: -350030786, displayValue: "Тестовая Группа", checked: false }
            ]
          },
          'Чат: ',
          -1001252662540,
          { required: false },
          true,
          null,
          classes.InlineInput),
        message: this.createInputConfig(
          'telegram-message',
          { id: "telegram-message" },
          'Сообщение: ',
          '',
          { required: true },
          false,
          {
            updateText: (elem, symbol) => { return this.updateText(elem, symbol) },
          })
    }
  }

  updateText = (elem, char) => {
    return elem.value.substring(0, elem.selectionStart) + "<" + char + ">" + elem.value.substring(elem.selectionStart, elem.selectionEnd) + "</" + char + ">" + elem.value.substring(elem.selectionEnd);
  }

  componentDidMount() {
    document.onkeydown = this.updateTextKey;
  }

  updateTextKey = (e) => {
    if (e.keyCode === 66 && e.ctrlKey) {
      const updatedForm = {...this.state.telegramMessageOptions};
      updatedForm.message.value = this.updateText(document.getElementById("telegram-message"), "b");
      this.setState({ telegramMessageOptions: updatedForm });
    } else if (e.keyCode === 73 && e.ctrlKey) {
      const updatedForm = {...this.state.telegramMessageOptions};
      updatedForm.message.value = this.updateText(document.getElementById("telegram-message"), "i");
      this.setState({ telegramMessageOptions: updatedForm });
    } else if (e.keyCode === 85 && e.ctrlKey) {
      const updatedForm = {...this.state.telegramMessageOptions};
      updatedForm.message.value = this.updateText(document.getElementById("telegram-message"), "u");
      this.setState({ telegramMessageOptions: updatedForm });
    } else if (e.keyCode === 69 && e.ctrlKey) {
      const updatedForm = {...this.state.telegramMessageOptions};
      updatedForm.message.value = this.updateText(document.getElementById("telegram-message"), "code");
      this.setState({ telegramMessageOptions: updatedForm });
    } else if (e.keyCode === 68 && e.ctrlKey) {
      const updatedForm = {...this.state.telegramMessageOptions};
      updatedForm.message.value = this.updateText(document.getElementById("telegram-message"), "s");
      this.setState({ telegramMessageOptions: updatedForm });
    }
  }

  sideBySide(ev) {
    ev.preventDefault();
    this.props.onSetSideBySide(!this.props.sideBySideMode);
  }

  checkValidity(value, rules) {
    let isValid = true;

    if (rules.required) {
        isValid = value.trim !== '' && isValid;
    }

    if (rules.type === 'email') {
      let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      isValid = re.test(value) && isValid;
    }

    if (rules.type == 'confirmPassword') {
      isValid = this.state.registerForm.password.value === value && isValid;
    }

    if (rules.minLength) {
      isValid = value.length >= rules.minLength && isValid;
    }

    if (rules.maxLength) {
      isValid = value.length <= rules.maxLength && isValid;
    }

    return isValid;
  }

  getErrorMessage(value, rules) {
    let errorMessage = '';

    if (rules.required && value.trim === '') {
      errorMessage = 'Это поле обязательное';
    }

    if (rules.type == 'email') {
      let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(value)) {
        errorMessage = 'Введите почту';
      }
    }

    if (rules.type == 'confirmPassword' && this.state.registerForm.password.value !== value) {
      errorMessage = 'Пароли должны совпадать';
    }

    if (rules.minLength && value.length < rules.minLength) {
      errorMessage = 'Минимальная длина: ' + rules.minLength;
    }

    if (rules.maxLength && value.length > rules.maxLength) {
      errorMessage = 'Максимальная длина: ' + rules.minLength;
    }

    return errorMessage;
  }

  inputChangedHandler = (event, elementId) => {
    const updatedOrderForm = {
      ...this.state.telegramMessageOptions
    }
    const updatedFormElement = {
      ...updatedOrderForm[elementId]
    }

    updatedFormElement.value = event.target.value;
    updatedOrderForm[elementId] = updatedFormElement;
    const updatedCard = {...this.state.localCard};
    updatedCard[elementId] = event.target.value;
    this.setState({ telegramMessageOptions : updatedOrderForm, localCard : updatedCard });
  }

  getTripRoute() {
    if (this.props.card.tripPoints) {
      let routeName = "";
      this.props.card.tripPoints.forEach((tripPoint, index) => {
        if (index < this.props.card.tripPoints.length - 1) {
          routeName += tripPoint.location.locationName + " --> ";
        } else {
          routeName += tripPoint.location.locationName;
        }
      });
      return routeName
    }
    return null;
  }

  getUnloadings() {
    let unload = "Выгрузки: ";
    let parsedUnloadings = [];
    Object.keys(this.props.card.unloadings).forEach((key, index) => {
      parsedUnloadings.push(key);
    });

    this.props.card.tripPoints.forEach(tripPoint => {
      let found = false;
      let items = parsedUnloadings.filter(unloading => {
        if (!found && unloading === tripPoint.location.locationName) {
          found = true;
          unload += this.props.card.unloadings[unloading].length + " в " + unloading + ", ";
          return false;
        } else {
          return true;
        }
      });
    });

    unload = unload.substring(0, unload.length - 2);
    return unload;
  }

  getId(id) {
    if (id < 10) {
      return "00" + id;
    } if (id < 100) {
      return "0" + id;
    }

    if (id.length == 3) {
      return id;
    } else {
      return id.toString().substring(id.toString().length - 3, id.toString().length);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.localCard === null && this.props.card != undefined && this.props.card.id != undefined) {
      const updatedTelegramForm = {...this.state.telegramMessageOptions};
      updatedTelegramForm.telegramOptions.value = 'Ищем машину';
      let message = "#рейс" + this.getId(this.props.card.id) + " Ищем машину " + this.props.card.capacity + " тн на " + this.props.card.date + " " + this.getTripRoute() + ". " + this.getUnloadings() + ".";
      if (this.props.card.price === 0) {
        message = "#рейс" + this.getId(this.props.card.id) + " Ищем машину " + this.props.card.capacity + " тн на " + this.props.card.date + " " + this.getTripRoute() + ". " + this.getUnloadings() + ".";
        updatedTelegramForm.telegramOptions.value = 'Ищем машину';
      } else if (this.props.card.price > 0 && !this.props.card.carrierConfirmed) {
        message = "#рейс" + this.getId(this.props.card.id) + " Предложена цена " + this.props.card.capacity + " тн на " + this.props.card.date + " " + this.getTripRoute() + ". " + this.getUnloadings() + " | " + this.props.card.price + ".";
        updatedTelegramForm.telegramOptions.value = 'Предложена цена';
      } else if (this.props.card.price > 0 && this.props.card.carrierConfirmed) {
        message = "#рейс" + this.getId(this.props.card.id) + " Найдена машина " + this.props.card.capacity + " тн на " + this.props.card.date + " " + this.getTripRoute() + ". " + this.getUnloadings() + " | " + this.props.card.price + ".";
        updatedTelegramForm.telegramOptions.value = 'Найдена машина';
      }
      updatedTelegramForm.message.value = message;
      this.setState({ selectedMessage: 'Ищем машину', telegramMessageOptions: updatedTelegramForm, localCard: {...this.props.card} });
    }

    if (this.props.card === null && this.state.localCard) {
      this.setState({ localCard: null });
    }

    if (this.state.telegramMessageOptions.telegramOptions.value !== this.state.selectedMessage) {
      let message = null;
      if (this.state.telegramMessageOptions.telegramOptions.value === "Ищем машину") {
        message = "#рейс" + this.getId(this.props.card.id) + " Ищем машину " + this.props.card.capacity + " тн на " + this.props.card.date + " " + this.getTripRoute() + ". " + this.getUnloadings() + ".";
      } else if (this.state.telegramMessageOptions.telegramOptions.value === "Изменения к рейсу") {
        message = "#рейс" + this.getId(this.props.card.id) + " Изменения к рейсу #" + this.props.card.id + " " + this.props.card.capacity + " тн на " + this.props.card.date + " " + this.getTripRoute() + ". " + this.getUnloadings();
      } else if (this.state.telegramMessageOptions.telegramOptions.value === "Предложена цена") {
        message = "#рейс" + this.getId(this.props.card.id) + " Предложена цена " + this.props.card.capacity + " тн на " + this.props.card.date + " " + this.getTripRoute() + ". " + this.getUnloadings() + " | " + this.props.card.price + ".";
      } else if (this.state.telegramMessageOptions.telegramOptions.value === "Найдена машина") {
        message = "#рейс" + this.getId(this.props.card.id) + " Найдена машина " + this.props.card.capacity + " тн на " + this.props.card.date + " " + this.getTripRoute() + ". " + this.getUnloadings() + " | " + this.props.card.price + ".";
      } else if (this.state.telegramMessageOptions.telegramOptions.value === "Ищем замену") {
        message = "#рейс" + this.getId(this.props.card.id) + " Ищем замену " + this.props.card.capacity + " тн на " + this.props.card.date + " " + this.getTripRoute() + ". " + this.getUnloadings() + ".";
      }

      const updatedTelegramForm = {...this.state.telegramMessageOptions};
      updatedTelegramForm.message.value = message;

      this.setState({ selectedMessage: this.state.telegramMessageOptions.telegramOptions.value, telegramMessageOptions: updatedTelegramForm });
    }

    if (this.state.telegramMessageOptions.channel.value !== this.state.selectedChannel) {
      this.setState({ selectedChannel: this.state.telegramMessageOptions.channel.value });
    }
  }

  sendMessage(ev) {
    ev.preventDefault();
    this.props.updateCard();
    let channels = this.state.telegramMessageOptions.channel.elementConfig.options;
    for (let i = 0; i < channels.length; i++) {
      let channel = channels[i];
      if (!channel.checked) {
        continue;
      }
      if (channel.value === "managers") {
        for (let i = 0; i < this.props.card.managers.length; i++) {
          if (this.props.card.managers[i].tbotId) {
            this.messageTelegram(
              this.props.card.managers[i].tbotId,
              this.state.telegramMessageOptions.message.value
            );
          } else {
            this.props.addNotification("У менеджера "+ this.props.card.managers[i].manager + " нет ид телеграма. Сообщение не отправлено", "Neutral");
          }
        }
      } else {
        this.messageTelegram(
          channel.value,
          this.state.telegramMessageOptions.message.value
        );
      }
    }
  }

  messageTelegram(chat, message) {
    let data = {
      chatId: chat,
      message: message
    };

    axios({
      method: 'post',
      url: '/api/v1/telegram/send',
      data: data,
      headers: {'Authorization': 'Bearer ' + this.props.access_token},
    })
    .then(response => {
      console.log(response);
      this.setState({ loading: false });
      this.props.addNotification("Сообщение отправлено успешно.", "Success");
    })
    .catch(error => {
      console.log(error);
      this.setState({ loading: false });
      if (error.response) {
        logError(
          this.props.access_token,
          this.props.codeToMessage[error.response.status],
          '/api/v1/telegram/send'
        );
        this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
      }
    });
  }

  sendManagersMessage(message, managers) {
    for (let i = 0; i < managers.length; i++) {
      for (let j = 0; j < this.props.card.managers.length; j++) {
        if (managers[i].name === this.props.card.managers[j]) {
          if (managers[i].tbotChatId) {
            this.messageTelegram(managers[i].tbotChatId, message);
          } else {
            this.props.addNotification("У менеджера " + managers[i].name + " нет ид телеграма. Сообщение не отправлено.", "Neutral");
          }
          break;
        }
      }
    }
  }

  parseMessage = (message) => {
    if (document.getElementById("message-preview")) {
      document.getElementById("message-preview").innerHTML = message;
    }
  }

  render () {
    let show = true;
    let card = null;

    if (this.state.localCard === null) {
      card = null;
      show = false;
    } else {
      const telegramMessageOptionsArray = [];
      for (let key in this.state.telegramMessageOptions) {
        telegramMessageOptionsArray.push({ id: key, config: this.state.telegramMessageOptions[key] });
      }

      let loading = null;
      if (this.state.loading) {
        loading = (
          <Spinner />
        )
      }

      let headerClasses = [classes.Header];
      headerClasses.push(classes.HeaderWhite);

      let sideBySideButton = (
        <ButtonIcon
          btnClass={classes.ButtonIconRound}
          clicked={(ev) => this.sideBySide(ev)}
          iconClass={classes.Icon}
          iconSource={sideBySideImg}
          small
          iconAlt=''></ButtonIcon>);

      if (this.props.sideBySideMode) {
        sideBySideButton = (
          <ButtonIcon
            btnClass={classes.ButtonIconRound}
            clicked={(ev) => this.sideBySide(ev)}
            iconClass={classes.Icon}
            iconSource={stackedImg}
            small
            iconAlt=''></ButtonIcon>);
      }

      card = (
        <Aux>
          <div className={headerClasses.join(' ')}>

            <div className={classes.CarrierTitle}>
              <Icon iconClass={classes.CarIcon} iconSource={telegramImg} iconAlt='' className={classes.CardIcon} />
              Телеграм
            </div>

            { sideBySideButton }

            <button className={classes.CloseButton} onClick={this.props.closeCard}>
              <Icon iconClass={classes.CloseIcon} iconSource={closeImg} iconAlt='' />
            </button>
            <p style={{height: "100%"}}></p>
          </div>

          <div className={classes.Body} >
            { loading }
            {telegramMessageOptionsArray.map(formElement => {
              return (
                <Input
                  key={formElement.id}
                  label={formElement.config.label}
                  elementType={formElement.config.elementType}
                  elementConfig={formElement.config.elementConfig}
                  value={formElement.config.value}
                  extraClass={formElement.config.extraClass}
                  extraAction={formElement.config.extraAction}
                  changed={(event) => this.inputChangedHandler(event, formElement.id)} />
                );
            })}

            <p id="message-preview"></p>
          </div>

          { loading }

          <div className={classes.Footer}>
            <div className={classes.FooterButtons}>
              <ButtonIcon
                btnType='Success'
                clicked={(ev) => this.sendMessage(ev)}
                disabled={this.state.loading}
                iconClass={classes.ButtonIcon}
                iconSource={chatImg}
                small
                iconAlt=''>ОТПРАВИТЬ</ButtonIcon>
            </div>
          </div>
        </Aux>
      );
    }

    let carrierClass = classes.CardModal;
    if (this.props.sideBySideMode) {
      carrierClass = classes.FullCardModal;
    }

    this.parseMessage(this.state.telegramMessageOptions.message.value);

    return(
      <Aux>
        <div
          className={carrierClass}
          style={{transform: show ? 'translateY(0)' : 'translateY(-100vh)',
                  opacity: show ? '1' : '0'}}>
          {card}
        </div>
      </Aux>
    );
  }
};

const mapStateToProps = state => {
  return {
    access_token: state.access_token,
    notifications: state.notifications,
    requests: state.requests,
    drivers: state.drivers,
    locations: state.locations,
    carriers: state.carriers,
    showNewCarrier: state.showNewCarrier,
    sideBySideMode: state.sideBySideMode,
    role: state.role,
    codeToMessage: state.codeToMessage
  };
}

const mapDispatchToProps = dispatch => {
  return {
    addNotification: (notification, notificationType) => dispatch({ type: actionTypes.ADD_NOTIFICATION,
                                                                   notification: notification,
                                                                   notificationType: notificationType }),
    resetNotifications: () => dispatch({ type: actionTypes.RESET_NOTIFICATION,
                                         notifications: [] }),
    onShowNewCarrier: (showNewCarrier) => dispatch({ type: actionTypes.SHOW_NEW_CARRIER, showNewCarrier: showNewCarrier }),
    onSetCarriers: (carriers) => dispatch({ type: actionTypes.SET_CARRIERS,
                                            carriers: carriers}),
    onSetSideBySide: (sideBySide) => dispatch({ type: actionTypes.SET_SIDE_BY_SIDE,
                                                sideBySide: sideBySide})
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TelegramModal);



// WEBPACK FOOTER //
// ./src/components/TelegramModal/TelegramModal.js